import { render, staticRenderFns } from "./ReserveRegistrationForm.vue?vue&type=template&id=03b80e40&"
import script from "./ReserveRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ReserveRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports